var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#555A66"
    },
    cx: 256,
    cy: 256,
    r: 256
  })))))))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333940"
    },
    d: "M511.81,265.405l-162.85-162.85l-38.4,143.025L158.25,93.269l-3.536,20.374l-19.445,2.607   l112.117,112.117L92.186,371.403l139.434,139.434C239.647,511.596,247.776,512,256,512C394.235,512,506.859,402.43,511.81,265.405z   "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AFB4C8"
    },
    cx: 353.18,
    cy: 317.644,
    r: 85.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#636978"
    },
    cx: 353.18,
    cy: 286.321,
    r: 39.202
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636978"
    },
    d: "M291.69,377.216c15.563,16.061,37.359,26.048,61.49,26.048s45.926-9.987,61.49-26.048     c-8.268-26.085-32.668-44.993-61.49-44.993C324.358,332.223,299.959,351.13,291.69,377.216z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BEC3D2"
    },
    cx: 158.82,
    cy: 317.644,
    r: 85.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#707789"
    },
    cx: 158.82,
    cy: 286.321,
    r: 39.202
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707789"
    },
    d: "M97.331,377.216c15.563,16.061,37.359,26.048,61.49,26.048s45.926-9.987,61.49-26.048     c-8.268-26.085-32.668-44.993-61.49-44.993C129.999,332.223,105.599,351.13,97.331,377.216z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 192.534,
    r: 85.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F6FC"
    },
    d: "M256,106.915c-0.032,0-0.063,0.002-0.095,0.002v171.235c0.032,0,0.063,0.002,0.095,0.002    c47.286,0,85.62-38.333,85.62-85.62C341.62,145.248,303.286,106.915,256,106.915z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#19CFFC"
    },
    cx: 256,
    cy: 161.212,
    r: 39.202
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41B3E5"
    },
    d: "M256,122.01c-0.032,0-0.063,0.002-0.095,0.002v78.399c0.032,0,0.063,0.002,0.095,0.002    c21.651,0,39.202-17.551,39.202-39.202C295.202,139.562,277.651,122.01,256,122.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19CFFC"
    },
    d: "M194.51,252.106c15.563,16.061,37.359,26.048,61.49,26.048s45.926-9.987,61.49-26.048    c-8.268-26.085-32.668-44.993-61.49-44.993C227.178,207.114,202.779,226.021,194.51,252.106z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41B3E5"
    },
    d: "M256,207.114c-0.032,0-0.063,0.002-0.095,0.002v71.037c0.032,0,0.063,0.001,0.095,0.001    c24.131,0,45.926-9.987,61.49-26.048C309.221,226.021,284.822,207.114,256,207.114z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19CFFC"
    },
    d: "M158.25,139.231c-7.539-19.052-3.929-15.442-22.981-22.981    c19.052-7.539,15.442-3.929,22.981-22.981c7.539,19.052,3.929,15.442,22.981,22.981    C162.179,123.789,165.789,120.179,158.25,139.231z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41B3E5"
    },
    d: "M348.96,196.925c-15.48-39.118-8.067-31.706-47.185-47.185    c39.118-15.479,31.706-8.067,47.185-47.185c15.48,39.118,8.067,31.706,47.185,47.185    C357.027,165.219,364.44,157.807,348.96,196.925z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.ca22c2a486e51befefa2f338c0997b7c.svg";
export { ForwardRef as ReactComponent };